/**
 * Filter for Profile Name it the name is too long
 */
var filter = function () {
    return function (input) {
        var output = angular.isDefined(input) ? input : "";
        if (output.length > 15) {
            return output.substring(0, 15) + "...";
        }
        else {
            return output;
        }
    };
};
var ɵ0 = filter;
export var ProfileFilter = {
    name: 'profileFilter',
    filter: filter
};
export { ɵ0 };
//# sourceMappingURL=fourdotfive-profile.filter.js.map